<template>
    <div class="recent-applications">
        <h4 class="title" v-if="recentApps.length">Recently Viewed</h4>
        <ul class="recent-list" v-if="status === 'ready'">
            <li class="list-item" v-for="(app, index) in recentApps" :key="index">
                <app-router-link class="recent-app" 
                    :url="app.Url"
                    :appId="app.Id"
                    :appName="__('Name', app)">
                    <app-avatar v-if="app.Avatar" :image="app.Avatar" :name="__('Name', app)"></app-avatar>
                    <span class="app-name">{{ __('Name', app) }}</span>
                </app-router-link>
            </li>
        </ul>
        <p class="status-message" v-if="status === 'loading'"><i class="fas fa-circle-notch fa-spin"></i></p>
        <button class="status-message retry" @click="init()" v-if="status === 'error'"><i class="fas fa-exclamation-triangle"></i>Retry</button>
    </div>
</template>


<script>
import AppAvatar from "@/components/dashboard/AppAvatar";
import AppRouterLink from "@/components/AppRouterLink";

export default {
    name: "recent-applications",
    components: {
        AppAvatar,
        AppRouterLink
    },
    data() {
        return {
            status: "ready",
            mode: "list",
            recentApps: []
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.status = "loading";
            try {
                if(localStorage.getItem('UserPreferences')){
                    this.recentApps = JSON.parse(localStorage.getItem('UserPreferences')).RecentApplications;
                    this.status = "ready";
                }
                else{
                    this.status = "error";
                }
            } catch (error) {
                this.status = "error";
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.recent-applications {
    padding: 0px $sidebar-padding;
    .title {
        margin: 0 0 10px 0;
        padding: 0;
        font-family: $raleway;
        font-size: 13px;
        font-weight: 700;
        text-transform: uppercase;
        color: $light-blue;
    }
    .status-message {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 0;
        width: 100%;
        height: 100%;
        color: $white;
        font-size: 18px;
        &.retry {
            font-size: 14px;
            color: $white;
            background: none;
            @include removeBootstrapOutline;
            @include fastestTransition;
            i {
                margin: 0px 10px 0px 0px;
            }
        }
    }
    .recent-list {
        padding: 0;
        margin: 0;
        list-style: none;
        .list-item {
            margin: 0px 0px 10px 0px;
            .recent-app {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-shrink: 0;
                color: $white!important;
                text-decoration: none;
                font-size: 14px;
                font-family: $roboto;
                font-weight: 400;
                line-height: 1.1;
                padding: 0;
                background: none;
                @include removeBootstrapOutline;
                @include fastestTransition;
                .app-avatar {
                    flex-shrink: 0;
                    width: 28px;
                    height: 28px;
                    border-radius: 2px;
                    margin: 0 10px 0 0;
                    .initials {
                        font-size: 14px;
                    }
                }
                .app-name {
                    text-align: left;
                }
                *:hover {
                    text-decoration: none;
                    color: $white;
                }
            }
            &:last-child {
                margin: 0;
            }
        }
    }
    @media screen and (max-width: $breakpoint-sm) {
        .recent-list {
            .list-item {
                .recent-app {
                    font-size: 12px;
                    .app-avatar {
                        width: 26px;
                        height: 26px;
                        .initials {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
}

.dark {
    .recent-applications {
        .title {
            color: $darker-gray;
        }
    }
}
</style>
